<!--
/**
 * APCWO customisation for OrangeHRM — Personal Review module.
 *
 * Licensed under the GNU General Public License v2.0 or later, the same terms
 * as OrangeHRM itself. See the LICENSE file at the project root.
 */
-->

<template>
  <div class="apcwo-pr-growth">
    <div class="apcwo-pr-growth__row apcwo-pr-growth__row--head">
      <span></span>
      <span>{{ headObjective }}</span>
      <span>Action to Achieve</span>
    </div>
    <div v-for="(row, i) in modelValue" :key="i" class="apcwo-pr-growth__row">
      <span class="apcwo-pr-growth__num">{{ i + 1 }}.</span>
      <oxd-input-field
        :model-value="row.objective"
        type="textarea"
        :disabled="disabled"
        @update:model-value="update(i, 'objective', $event)"
      />
      <oxd-input-field
        :model-value="row.action"
        type="textarea"
        :disabled="disabled"
        @update:model-value="update(i, 'action', $event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'GrowthRows',
  props: {
    modelValue: {
      type: Array,
      required: true,
    },
    headObjective: {
      type: String,
      default: 'Objective',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  methods: {
    update(index, field, value) {
      const rows = this.modelValue.map((r, i) =>
        i === index ? {...r, [field]: value} : r,
      );
      this.$emit('update:modelValue', rows);
    },
  },
};
</script>

<style>
.apcwo-pr-growth__row {
  display: grid;
  grid-template-columns: 32px 1fr 1fr;
  gap: 12px;
  align-items: start;
  margin-bottom: 10px;
}
.apcwo-pr-growth__row--head {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #8a8a99;
  margin-bottom: 4px;
}
.apcwo-pr-growth__num {
  padding-top: 10px;
  font-weight: 700;
  color: #741e1e;
}
.apcwo-pr-growth textarea {
  min-height: 70px;
}
@media (max-width: 700px) {
  .apcwo-pr-growth__row {
    grid-template-columns: 1fr;
  }
}
</style>
